var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import { ChartSeriesVisibility } from '@web/components/layout/RechartsItems/ChartSeriesVisibility';
import CustomTooltip from '@web/components/layout/RechartsItems/CustomTooltip';
import { createEdgePositionedBarTooltipContent } from '@web/components/layout/RechartsItems/EdgePositionedBarTooltip';
import LegendItem from '@web/components/layout/RechartsItems/LegendItem';
import { Widget } from '@web/components/layout/Widget';
import { WidgetChartPlotArea } from '@web/components/layout/WidgetChartPlotArea/WidgetChartPlotArea';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { MEETING_LOAD_COLORS_CONFIG, TablesDiffColorsConfig } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { isAiButtonDisabled, isInsightsDataEmpty } from '@web/utility';
import { hasTeamAverageTotals } from '@web/utility/ tooltip/periodComparisonTooltip';
import { formatChartDayPeriodAxisLabel, getPeriodBarChartLayoutProps } from '@web/utility/charts';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { ComparisonPeriod, navigateFromPeriodChartBarClick } from '@web/utility/searchMeetingsNavigation';
import { InsightTypeEnum, MEETING_LOAD_KEYS, MEETING_LOAD_USER_KEYS } from '@workalizer/shared';
import { diffComparisonType, diffComparisonValueFormat } from '@workalizer/shared/types';
import { formatDuration, getInterval, getPercentageDiff } from '@workalizer/shared/utils';
import { useTranslation } from 'react-i18next';
import { Bar, CartesianGrid, ComposedChart, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
var SECONDS_PER_HOUR = 3600;
var formatMeetingLoadValue = function (key, value) {
    if (key === 'meetingCount') {
        return String(value);
    }
    if (key === 'avgParticipants') {
        return value.toFixed(1);
    }
    return formatDuration(value, 'seconds');
};
var asNumber = function (value) { return Number(value !== null && value !== void 0 ? value : 0); };
var teamDiffOptions = {
    comparisonType: diffComparisonType.teamAverage
};
var getMeetingLoadPeriodDiff = function (dataKey, row) {
    if (!row) {
        return undefined;
    }
    if (dataKey === 'meetingCount') {
        return getPercentageDiff(asNumber(row.prevMeetingCount), asNumber(row.meetingCount));
    }
    if (dataKey === 'durationHours') {
        return getPercentageDiff(asNumber(row.prevDurationSeconds), asNumber(row.durationSeconds), { comparisonValueFormat: diffComparisonValueFormat.durationSeconds });
    }
    if (dataKey === 'manHours') {
        return getPercentageDiff(asNumber(row.prevManHoursSeconds), asNumber(row.manHoursSeconds), { comparisonValueFormat: diffComparisonValueFormat.durationSeconds });
    }
    if (dataKey === 'avgParticipants') {
        return getPercentageDiff(asNumber(row.prevAvgParticipants), asNumber(row.avgParticipants));
    }
    return undefined;
};
var getMeetingLoadTeamDiff = function (dataKey, row) {
    if (!row) {
        return undefined;
    }
    if (dataKey === 'meetingCount') {
        return getPercentageDiff(asNumber(row.teamMeetingCount), asNumber(row.meetingCount), teamDiffOptions);
    }
    if (dataKey === 'durationHours') {
        return getPercentageDiff(asNumber(row.teamDurationSeconds), asNumber(row.durationSeconds), __assign(__assign({}, teamDiffOptions), { comparisonValueFormat: diffComparisonValueFormat.durationSeconds }));
    }
    if (dataKey === 'manHours') {
        return getPercentageDiff(asNumber(row.teamManHoursSeconds), asNumber(row.manHoursSeconds), __assign(__assign({}, teamDiffOptions), { comparisonValueFormat: diffComparisonValueFormat.durationSeconds }));
    }
    if (dataKey === 'avgParticipants') {
        return getPercentageDiff(asNumber(row.teamAvgParticipants), asNumber(row.avgParticipants), teamDiffOptions);
    }
    return undefined;
};
var MeetingLoadParticipants = function () {
    var t = useTranslation().t;
    var _a = useFilters(), dateFrom = _a.dateFrom, dateTo = _a.dateTo, orgUnit = _a.orgUnit, user = _a.user;
    var navigateTo = useNavigateTo();
    var _b = trpc.meetingLoadAnalytic.useQuery({
        dateFrom: dateFrom,
        dateTo: dateTo,
        userId: user,
        orgUnitId: orgUnit
    }), data = _b.data, isLoading = _b.isLoading, refetch = _b.refetch;
    if (isLoading || !data) {
        return _jsx(Loading, {});
    }
    var showTeamAverage = Boolean(user) && hasTeamAverageTotals(data.totals);
    var showTeamMetrics = user == null;
    var visibleSeriesKeys = showTeamMetrics
        ? MEETING_LOAD_KEYS
        : MEETING_LOAD_USER_KEYS;
    var interval = getInterval(dateFrom, dateTo);
    var chartData = data.periods.map(function (period) {
        var _a, _b, _c, _d, _e, _f, _g;
        return (__assign(__assign({ period: period.period, previousPeriodLabel: period.previousPeriodLabel, meetingCount: period.meetingCount, durationHours: period.durationSeconds / SECONDS_PER_HOUR }, (showTeamMetrics && {
            manHours: ((_a = period.manHoursSeconds) !== null && _a !== void 0 ? _a : 0) / SECONDS_PER_HOUR,
            avgParticipants: (_b = period.avgParticipants) !== null && _b !== void 0 ? _b : 0,
            manHoursSeconds: (_c = period.manHoursSeconds) !== null && _c !== void 0 ? _c : 0,
            prevManHoursSeconds: (_d = period.prevManHoursSeconds) !== null && _d !== void 0 ? _d : 0,
            prevAvgParticipants: (_e = period.prevAvgParticipants) !== null && _e !== void 0 ? _e : 0,
            teamManHoursSeconds: (_f = period.teamManHoursSeconds) !== null && _f !== void 0 ? _f : 0,
            teamAvgParticipants: (_g = period.teamAvgParticipants) !== null && _g !== void 0 ? _g : 0
        })), { durationSeconds: period.durationSeconds, prevMeetingCount: period.prevMeetingCount, prevDurationSeconds: period.prevDurationSeconds, teamMeetingCount: period.teamMeetingCount, teamDurationSeconds: period.teamDurationSeconds }));
    });
    var _c = getPeriodBarChartLayoutProps({
        barGroupCount: chartData.length,
        barsPerGroup: showTeamMetrics ? 3 : 2
    }), barGap = _c.barGap, barSize = _c.barSize, periodXAxis = _c.periodXAxis, periodBarChartMargin = _c.periodBarChartMargin;
    var chartPlotEmpty = isInsightsDataEmpty(data);
    var seriesOrder = showTeamMetrics
        ? ['meetingCount', 'durationHours', 'manHours', 'avgParticipants']
        : ['meetingCount', 'durationHours'];
    var seriesLabels = {
        meetingCount: t('app.apps.meeting.meetingLoad.series.meetingCount'),
        durationHours: t('app.apps.meeting.meetingLoad.series.duration'),
        manHours: t('app.apps.meeting.meetingLoad.series.manHours'),
        avgParticipants: t('app.apps.meeting.meetingLoad.series.avgParticipants')
    };
    var renderTooltip = createEdgePositionedBarTooltipContent(_jsx(CustomTooltip, { seriesOrder: seriesOrder, seriesLabelFormatter: function (dataKey) { var _a; return (_a = seriesLabels[dataKey]) !== null && _a !== void 0 ? _a : dataKey; }, getPeriodDiff: getMeetingLoadPeriodDiff, getTeamDiff: showTeamAverage ? getMeetingLoadTeamDiff : undefined, periodDiffArrowColor: TablesDiffColorsConfig.GREEN, formatValue: function (value, dataKey, _label, row) {
            var _a, _b;
            if (dataKey === 'meetingCount' || dataKey === 'avgParticipants') {
                return formatMeetingLoadValue(dataKey, Number(value));
            }
            if (dataKey === 'durationHours') {
                return formatDuration(Number((_a = row === null || row === void 0 ? void 0 : row.durationSeconds) !== null && _a !== void 0 ? _a : value * SECONDS_PER_HOUR), 'seconds');
            }
            if (dataKey === 'manHours') {
                return formatDuration(Number((_b = row === null || row === void 0 ? void 0 : row.manHoursSeconds) !== null && _b !== void 0 ? _b : value * SECONDS_PER_HOUR), 'seconds');
            }
            return String(value);
        } }), chartData.length);
    var legendItems = visibleSeriesKeys.map(function (key) { return ({
        key: key,
        currentValue: formatMeetingLoadValue(key, data.totals[key].current),
        diffValue: data.totals[key].previous,
        teamAverage: showTeamAverage ? data.totals[key].teamAverage : undefined
    }); });
    var handlePeriodBarClick = function (barData, fallbackIndex) {
        navigateFromPeriodChartBarClick({
            chartData: chartData,
            barData: barData,
            fallbackIndex: fallbackIndex,
            stack: ComparisonPeriod.Current,
            navigateTo: navigateTo,
            dateFrom: dateFrom,
            dateTo: dateTo,
            userId: user,
            orgUnitId: orgUnit
        });
    };
    return (_jsxs("div", { children: [_jsx(WidgetTitle, { title: t('app.apps.meeting.meetingLoad.title'), description: "widgetTitleDescriptions.apps.meetingLoadAnalytic", insightType: InsightTypeEnum.meetingLoadAnalytic, insightsData: data, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('app.apps.meeting.meetingLoad.title'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, data.periods.map(function (period) {
                                    var _a, _b, _c, _d;
                                    var _e, _f, _g, _h;
                                    return (__assign(__assign((_a = {}, _a[t('filters.period')] = period.period, _a[t('app.apps.meeting.meetingLoad.series.meetingCount')] = period.meetingCount, _a[t('app.apps.meeting.meetingLoad.series.duration')] = formatDuration(period.durationSeconds, 'seconds'), _a), (showTeamMetrics && (_b = {},
                                        _b[t('app.apps.meeting.meetingLoad.series.manHours')] = formatDuration((_e = period.manHoursSeconds) !== null && _e !== void 0 ? _e : 0, 'seconds'),
                                        _b[t('app.apps.meeting.meetingLoad.series.avgParticipants')] = (_f = period.avgParticipants) !== null && _f !== void 0 ? _f : 0,
                                        _b))), (showTeamAverage && __assign((_c = {}, _c["".concat(t('export.teamAverage'), " ").concat(t('app.apps.meeting.meetingLoad.series.meetingCount'))] = period.teamMeetingCount, _c["".concat(t('export.teamAverage'), " ").concat(t('app.apps.meeting.meetingLoad.series.duration'))] = formatDuration(period.teamDurationSeconds, 'seconds'), _c), (showTeamMetrics && (_d = {},
                                        _d["".concat(t('export.teamAverage'), " ").concat(t('app.apps.meeting.meetingLoad.series.manHours'))] = formatDuration((_g = period.teamManHoursSeconds) !== null && _g !== void 0 ? _g : 0, 'seconds'),
                                        _d["".concat(t('export.teamAverage'), " ").concat(t('app.apps.meeting.meetingLoad.series.avgParticipants'))] = (_h = period.teamAvgParticipants) !== null && _h !== void 0 ? _h : 0,
                                        _d))))));
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(data) }) }), _jsx(ChartSeriesVisibility, __assign({ seriesKeys: __spreadArray([], visibleSeriesKeys, true) }, { children: function (_a) {
                    var _b;
                    var toggleSeries = _a.toggleSeries, isSeriesVisible = _a.isSeriesVisible;
                    return (_jsxs(Widget, __assign({ cardClassName: "shadow overflow-x-auto lg:overflow-visible border-b border-gray-200 sm:rounded-lg p-6", className: "lock w-full max-w-full py-2 align-middle sm:px-6 lg:pl-2 lg:pr-2" }, { children: [_jsx("div", __assign({ className: "mb-6 ml-2 flex flex-wrap justify-start gap-8 rounded-lg p-4 lg:gap-8" }, { children: _jsx("div", __assign({ className: "flex flex-col flex-wrap justify-start gap-2 lg:flex-row lg:gap-4" }, { children: legendItems.map(function (_a) {
                                        var key = _a.key, currentValue = _a.currentValue, diffValue = _a.diffValue, teamAverage = _a.teamAverage;
                                        return (_jsx(LegendItem, { color: MEETING_LOAD_COLORS_CONFIG[key].color, label: t("app.apps.meeting.meetingLoad.series.".concat(MEETING_LOAD_COLORS_CONFIG[key].translationKey)), currentValue: currentValue, diffValue: diffValue, teamAverage: teamAverage, arrowColor: TablesDiffColorsConfig.GREEN, onClick: function () { return toggleSeries(key); }, isHidden: !isSeriesVisible(key) }, key));
                                    }) })) })), _jsx(WidgetChartPlotArea, __assign({ isEmpty: chartPlotEmpty }, { children: _jsx(ResponsiveContainer, __assign({ width: "100%", height: 400 }, { children: _jsxs(ComposedChart, __assign({ data: chartData, barGap: barGap, barSize: barSize, margin: __assign(__assign({}, periodBarChartMargin), { right: Math.max((_b = periodBarChartMargin.right) !== null && _b !== void 0 ? _b : 12, 28) }) }, { children: [_jsx(CartesianGrid, { strokeDasharray: "3 3", stroke: "#f3f4f6" }), _jsx(XAxis, __assign({ dataKey: "period", axisLine: false, tickLine: false }, periodXAxis, { tickFormatter: function (value) {
                                                    return formatChartDayPeriodAxisLabel(value, interval, {
                                                        dateFrom: dateFrom,
                                                        dateTo: dateTo
                                                    });
                                                } })), _jsx(YAxis, { yAxisId: "left", axisLine: false, tickLine: false, tick: { fontSize: 12, fill: '#6b7280' }, allowDecimals: false }), _jsx(YAxis, { yAxisId: "right", orientation: "right", axisLine: false, tickLine: false, tick: { fontSize: 12, fill: '#6b7280' }, allowDecimals: false }), _jsx(Tooltip, { allowEscapeViewBox: { x: true, y: true }, content: renderTooltip }), _jsx(Bar, { yAxisId: "left", dataKey: "meetingCount", fill: MEETING_LOAD_COLORS_CONFIG.meetingCount.chartColor, radius: [4, 4, 0, 0], hide: !isSeriesVisible('meetingCount'), onClick: function (barData, index) {
                                                    return handlePeriodBarClick(barData, index);
                                                }, style: { cursor: 'pointer' } }), _jsx(Bar, { yAxisId: "right", dataKey: "durationHours", fill: MEETING_LOAD_COLORS_CONFIG.durationSeconds.chartColor, radius: [4, 4, 0, 0], hide: !isSeriesVisible('durationSeconds'), onClick: function (barData, index) {
                                                    return handlePeriodBarClick(barData, index);
                                                }, style: { cursor: 'pointer' } }), showTeamMetrics ? (_jsxs(_Fragment, { children: [_jsx(Bar, { yAxisId: "right", dataKey: "manHours", fill: MEETING_LOAD_COLORS_CONFIG.manHoursSeconds.chartColor, radius: [4, 4, 0, 0], hide: !isSeriesVisible('manHoursSeconds'), onClick: function (barData, index) {
                                                            return handlePeriodBarClick(barData, index);
                                                        }, style: { cursor: 'pointer' } }), _jsx(Line, { yAxisId: "left", type: "monotone", dataKey: "avgParticipants", stroke: MEETING_LOAD_COLORS_CONFIG.avgParticipants.chartColor, strokeWidth: 2, dot: {
                                                            r: 4,
                                                            fill: MEETING_LOAD_COLORS_CONFIG.avgParticipants
                                                                .chartColor,
                                                            strokeWidth: 0
                                                        }, activeDot: { r: 5 }, hide: !isSeriesVisible('avgParticipants'), onClick: function (lineData) {
                                                            return handlePeriodBarClick(lineData, 0);
                                                        }, style: { cursor: 'pointer' } })] })) : null] })) })) }))] })));
                } }))] }));
};
export default MeetingLoadParticipants;
